module.exports = __webpack_public_path__ + "img/solicitud-ingresada-1.ced36903.png";